"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RadioButtonGroup;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _RadioInput = _interopRequireDefault(require("./RadioInput"));

function RadioButtonGroup(props) {
  var options = props.options,
      onChange = props.onChange;

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selection = _useState2[0],
      setSelection = _useState2[1];

  function changeSelection(selection) {
    setSelection(selection);
    onChange(selection);
  }

  return options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_RadioInput["default"], {
      key: option,
      value: option,
      checked: option === selection,
      onChange: function onChange(e) {
        changeSelection(e.currentTarget.value);
      }
    }, option);
  });
}